module.exports = __webpack_public_path__ + "img/bg.7c479c2b.png";